<template>
  <v-layout column class="shrink">
    <v-row no-gutters>
      <h2>My Resources</h2>
      <v-spacer></v-spacer>
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" v-on="on">
            <span class="grey--text pr-1">Filter By Project: </span> {{ contextProjectFilter }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in ['All', 'Project A', 'Project B']"
            :key="index"
            @click="contextProjectFilter = item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-row>
      <v-col cols="4">
        <v-card class="px-8 py-4 transparent" flat>
          <span class="subtitle-1 mb-2">Newly Added Resources</span>
          <v-list dense color="transparent">
            <v-list-item v-for="resource in recentResources" :key="resource.id" @click="">
              <resource-block
                variant="listItem"
                :blockData="{ resource: resource }"
                blockType="block"
                style="max-width: 100%;"
              ></resource-block>
            </v-list-item>
          </v-list>
          <v-btn text><v-icon>add</v-icon> New Context</v-btn>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="px-8 py-4 transparent" flat>
          <span class="subtitle-1 mb-2">Unused Resources</span>
          <v-list dense color="transparent">
            <v-list-item v-for="resource in unusedResources" :key="resource.id" @click="">
              <resource-block
                variant="listItem"
                :blockData="{ resource: resource }"
                blockType="block"
              ></resource-block>
            </v-list-item>
          </v-list>
          <v-btn text><v-icon>add</v-icon> New Context</v-btn>
        </v-card>
      </v-col>
      <v-col cols="3" style="opacity: 0.8">
        <v-card class="px-8 py-4" color="" outlined>
          <h3 class="headline mb-2"></h3>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ResourceBlock from '@/components/Resources/ResourceBlock';
export default {
  components: { ResourceBlock },
  data() {
    return {
      contextProjectFilter: 'All'
    };
  },
  computed: {
    ...mapGetters('userWorkspaceLite', [
      'userWorkspaceLites',
      // 'allUserDocuments',
      'workspaceResources'
    ]),
    ...mapState('userWorkspaceLite', ['allUserDocuments']),
    ...mapGetters('workspaces', ['workspaceContexts']),
    allResources() {
      const w = this.workspaceResources;
      return w.sort((a, b) => {
        if (a.createdOn.toDate() < b.createdOn.toDate()) {
          return 1;
        } else {
          return -1;
        }
      });
    },
    recentResources() {
      const r = this.allResources;

      return r
        .sort((a, b) => {
          if (a.createdOn.toDate() < b.createdOn.toDate()) {
            return 1;
          } else {
            return -1;
          }
        })
        .slice(0, 10);
    },
    unusedResources() {
      const r = this.allResources.filter(r => !r.usedOn.length);
      return r
        .sort((a, b) => {
          if (a.createdOn.toDate() < b.createdOn.toDate()) {
            return 1;
          } else {
            return -1;
          }
        })
        .slice(0, 10);
    }
  }
};
</script>

<style></style>
